import Text from '$tablet-app/src/app/components/Text';
import React, { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import ChatWidget from '../ChatWidget';
import ChatWidgetHeader from '../ChatWidgetHeader';

interface Props {
  location?: string;
  date?: string;
  time?: string;
}

const ChatClockView: FC<Props> = ({ location, date, time }) => {
  return (
    <ChatWidget
      header={<ChatWidgetHeader header_text="CLOCK" icon={['fas', 'clock']} />}
    >
      <View style={styles.clock_items}>
        <View style={styles.text_container}>
          <Text style={styles.location_text} variant="h3" weight="bold">
            {location}
          </Text>
          <Text style={styles.date_text} variant="p" weight="regular">
            {date}
          </Text>
        </View>
        <Text style={styles.time_text}>{time}</Text>
      </View>
    </ChatWidget>
  );
};
export default ChatClockView;

const styles = StyleSheet.create({
  clock_items: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap-reverse',
    padding: 10,
  },
  text_container: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: 1,
    minWidth: '40%',
  },
  location_text: {
    color: 'white',
    paddingBottom: 11,
  },
  date_text: {
    color: 'white',
  },
  time_text: {
    color: 'white',
    fontSize: 48,
    fontWeight: '700',
    padding: 0,
  },
});
